// Application configuration
// All URLs should be relative or configured via environment variables

export const APP_CONFIG = {
  // API configuration
  api: {
    // Use relative URL by default - works on any domain
    baseURL: import.meta.env.VITE_API_URL || "/api",
    timeout: 60000, // Increased to 60 seconds for large data requests
    longTimeout: 120000, // 2 minutes for GSC data fetching with filters
  },

  // App metadata
  app: {
    name: "Semantica Promodo",
    version: "1.0.0",
  },
};

// Helper to ensure URLs work on any domain
export function getApiUrl(path: string = ""): string {
  const baseURL = APP_CONFIG.api.baseURL;

  // If baseURL is already a full URL (for development), use it
  if (baseURL.startsWith("http://") || baseURL.startsWith("https://")) {
    return baseURL + path;
  }

  // Otherwise, use relative URL (for production)
  return path.startsWith("/") ? path : "/" + path;
}
